import api from "@/lib/api";

/**
 * Change Requests API — admin approval system endpoints.
 * Shared backend with the mobile app; all writes for company users are
 * intercepted server-side and queued as pending change requests.
 */
export const changeRequestsApi = {
  // Admin
  list: (status = "pending", limit = 200) =>
    api.get("/admin/change-requests", { params: { status, limit } }).then((r) => r.data),

  pendingCount: () =>
    api.get("/admin/change-requests/pending-count").then((r) => r.data),

  approve: (id, adminNote) =>
    api.post(`/admin/change-requests/${id}/approve`, adminNote ? { admin_note: adminNote } : {}).then((r) => r.data),

  reject: (id, adminNote) =>
    api.post(`/admin/change-requests/${id}/reject`, adminNote ? { admin_note: adminNote } : {}).then((r) => r.data),

  // Company self-view
  mine: (status = "") =>
    api.get("/company/my-change-requests", { params: status ? { status } : {} }).then((r) => r.data),
};

/**
 * Human labels for change-request badges & summaries.
 * `type` = "{target_type}:{action}"  e.g. "client:create"
 */
export const CR_TYPE_META = {
  "client:create":  { label: "إضافة عميل", color: "#22C55E", bg: "rgba(34,197,94,0.15)",  border: "rgba(34,197,94,0.5)"  },
  "client:update":  { label: "تعديل عميل", color: "#C9A961", bg: "rgba(201,169,97,0.15)", border: "rgba(201,169,97,0.5)" },
  "client:delete":  { label: "حذف عميل",  color: "#EF4444", bg: "rgba(239,68,68,0.15)",  border: "rgba(239,68,68,0.5)"  },
  "booking:create": { label: "حجز جديد",  color: "#38BDF8", bg: "rgba(56,189,248,0.15)", border: "rgba(56,189,248,0.5)" },
};

export const CR_STATUS_META = {
  pending:  { label: "قيد المراجعة", color: "#F59E0B" },
  approved: { label: "معتمد",       color: "#22C55E" },
  rejected: { label: "مرفوض",       color: "#EF4444" },
};
